import { Box, Typography, Card, IconButton, styled, Divider } from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useState } from "react";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CheckCircle } from "@mui/icons-material";
import axios from "axios";
import { toast } from "react-toastify";

// Answer type
export type Answer = { answer: string; correct: boolean; };



// export type AdminDropdownCardProps = {
//   question?: string;
//   structure?: number;
//   suggestedAnswers?: Answer[];
//   index?: number;
//   questionId?: string;
//   onEdit?: () => void;
// };

const CustomButtonStyle = styled(IconButton)({
    border: '1px solid var(--Interviewer-Near-White)',
    borderRadius: '8px',
    width: '40px',
    height: '40px'
})


// Novo
interface SuggestedAnswer {
  answer: string;
  correct: boolean;
}
interface AdminDropdownCardProps {
  questionId: string,
  structure: number,
  questionText: string,
  suggestedAnswers: SuggestedAnswer[]
  index: number,
  onEdit: (question: {
    id: string;
    structure: number;
    text: string;
    suggestedAnswers: SuggestedAnswer[];
  }) => void;
}


const AdminDropdownCard = ({ questionId, structure, questionText, suggestedAnswers, index, onEdit }: AdminDropdownCardProps) => {

  const [isExpanded, setIsExpanded] = useState(false);
  const queryClient = useQueryClient();

  // Brisanje pitanja
  const deleteQuestionMutation = useMutation({
    mutationFn: async(id) => {
      const token = localStorage.getItem('token');
      const results = await axios.delete(`https://interviewer.runasp.net/api/questions/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      })
      return results;
    },
    onSuccess: (data) => {
      toast.success('Successfully deleted question!')
      queryClient.invalidateQueries({ queryKey: ['category-questions'] });
      console.log(data);
    },
    onError: (error) => {
      console.log(error);
    }
  })

  return (
    <Card sx={{
      borderRadius: '16px',
      boxShadow: ' 0px 1px 2px 0px #0205111A',
      background: '#fff',
      border: '1px solid var(--Light-Gray)',
      padding: '24px'
    }}>
      <Box>

        <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'center' }, mb: '16px'}}>
          <Box sx={{ display: 'flex', flexDirection: {xs: 'column', md: 'row'}, alignItems: {xs: 'start', md: 'center'}, gap: {xs: '4px', md: '18px'}}}>
            <Typography variant="h3">
              Question {index+1}
            </Typography>
            <Box sx={{
              background: 'var(--Lightest-Green)',
              color: 'var(--Interviewer-Green)',
              fontWeight: 600,
              borderRadius: '8px',
              fontSize: '14px',
              px: '14px',
              py: '6px',
            }}>
              {structure === 1 ? 'Text' : structure === 2 ? '1 Answer' : 'Multiple Choice'}
            </Box>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{display: 'flex', gap: '10px', alignItems: 'center'}}>
              <CustomButtonStyle 
                onClick={() => onEdit({
                  id: questionId,
                  structure: structure,
                  text: questionText,
                  suggestedAnswers: suggestedAnswers
                })}
              >
                <ModeEditOutlineOutlinedIcon fontSize="small" color="primary" sx={{width: '18px', height: '18px'}}/>
              </CustomButtonStyle>
              <CustomButtonStyle onClick={() => deleteQuestionMutation.mutate(questionId)}>
                <DeleteOutlineOutlinedIcon fontSize="small" color="primary" sx={{width: '18px', height: '18px'}} />
              </CustomButtonStyle>
            </Box>
            <IconButton onClick={() => setIsExpanded(e => !e)} sx={{padding: '8px', width: '40px', height: '40px', borderRadius: '0px', ml: '4px'}}>
              {isExpanded ? <KeyboardArrowUpOutlinedIcon fontSize="small" color="primary" sx={{width: '24px', height: '24px'}}/> : <KeyboardArrowDownIcon fontSize="small" color="primary" sx={{width: '24px', height: '24px'}}/>}
            </IconButton>
          </Box>
        </Box>
        {isExpanded && (
          <Divider sx={{mb: '24px'}}/>
        )}
      </Box>

      <Typography sx={{fontWeight: 600, color: 'var(--Interviewer-Lighter-Black)', fontSize: '14px', pb: '24px' }}>
        { questionText }
      </Typography>

      {isExpanded && (
        <Box sx={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
          <Typography variant="h4" sx={{fontWeight: '600', color: 'var(--Interviewer-Black)'}}>Answer</Typography>
          {structure === 1 && suggestedAnswers.length > 0 && (
            <Box sx={{
              display: 'flex',
                alignItems: 'center',
                gap: '16px',
                border: '1px solid var(--Interviewer-Green)',
                borderRadius: '12px',
                p: '16px',
                color: 'var(--Interviewer-Lighter-Black)',
                fontWeight: 600,
                fontSize: '14px',
                boxShadow: '0px 1px 2px 0px #0205111A'
            }}>
              <CheckCircle
                fontSize="small"
                sx={{
                  color:'var(--Interviewer-Green)',
                  cursor: 'pointer',
                  maxWidth: '16px',
                  maxHeight: '16px'
                }}
              />
              {suggestedAnswers[0].answer}
            </Box>
          )}
          {(structure === 2 || structure === 3) && suggestedAnswers.map((a, i) => (
            <Box
              key={i}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                border: a.correct ? '1px solid var(--Interviewer-Green)' : '1px solid var(--Light-Gray)',
                borderRadius: '12px',
                p: '16px',
                color: 'var(--Interviewer-Lighter-Black)',
                fontWeight: 600,
                fontSize: '14px',
                boxShadow: '0px 1px 2px 0px #0205111A'
              }}
            >
              {a.correct ? 
                <CheckCircle
                  fontSize="small"
                  sx={{
                    color:'var(--Interviewer-Green)',
                    cursor: 'pointer',
                    maxWidth: '16px',
                    maxHeight: '16px'
                  }}
                />
              : 
               <CheckCircle
                fontSize="small"
                sx={{
                  color:'var(--Interviewer-Lightest-Black)',
                  cursor: 'pointer',
                  maxWidth: '16px',
                  maxHeight: '16px'
                }}
              />}
              {a.answer}
            </Box>
          ))}
        </Box>
      )}
    </Card>
  );
};

export default AdminDropdownCard;